import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Description, Image, Layout, StyledSecondaryLink, Title, TitleContainer } from './FavoriteGuideTeaser.styles';
import { useInitialRender } from '../../../../../play-core/hooks/use-initial-render';
import SvgClose from '../../../../../play-core/icons/Close';
import { imagesBasePath } from '../../../../../play-core/utils/base-path';
import { useAnalyticsDispatch } from '../../../analytics/AnalyticsContext';
import { useUdpSectionTracking } from '../../../analytics/use-udp-section-tracking';
import { TransparentButton } from '../../../components/ClickableComponents/Button';
import { useSectionMeta } from '../../../components/Section/SectionMetaProvider';
import { usePath, useVideoConfig } from '../../../config/VideoAppContext';
import { useDataDispatch, useFavoriteGuideState, usePersonalizationSettings } from '../../../providers/DataProvider/DataContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const FavoriteGuideTeaser = ({
  callbackUrl
}) => {
  const {
    t
  } = useTranslation();
  const {
    businessUnit,
    favoritesSupported
  } = useVideoConfig();
  const {
    favoriteGuideTopicsPath
  } = usePath();
  const analytics = useAnalyticsDispatch();
  const {
    showFavoriteGuide
  } = useFavoriteGuideState();
  const dispatch = useDataDispatch();
  const {
    isActive
  } = usePersonalizationSettings();
  const isInitialRender = useInitialRender();
  const sectionMeta = useSectionMeta();
  const trackSection = useUdpSectionTracking();
  if (!showFavoriteGuide || !isActive || isInitialRender || !favoritesSupported) return /*#__PURE__*/_jsx(Fragment, {});
  return /*#__PURE__*/_jsxs(Layout, {
    children: [/*#__PURE__*/_jsxs(TitleContainer, {
      children: [/*#__PURE__*/_jsx(Title, {
        children: t('favoriteGuide.teaser.title')
      }), /*#__PURE__*/_jsx(TransparentButton, {
        type: "icon",
        ariaLabel: t('global.close'),
        iconSize: 32,
        icon: /*#__PURE__*/_jsx(SvgClose, {}),
        onClick: () => {
          dispatch({
            type: 'set-favorite-guide',
            favoriteGuide: false
          });
          analytics({
            type: 'click-event',
            name: 'CloseFavoriteGuideTeaser',
            value1: callbackUrl
          });
          if (sectionMeta.representationName) {
            trackSection({
              sectionMeta
            });
          }
        }
      })]
    }), /*#__PURE__*/_jsx(Image, {
      alt: "GuideFavorite",
      src: `${imagesBasePath}/favoriteGuide/favoriteGuide-${businessUnit}.png`
    }), /*#__PURE__*/_jsx(Description, {
      children: t('favoriteGuide.teaser.description')
    }), /*#__PURE__*/_jsx(StyledSecondaryLink, {
      type: "text",
      text: t('favoriteGuide.teaser.button'),
      to: favoriteGuideTopicsPath(callbackUrl),
      isInternal: true,
      onClick: () => analytics({
        type: 'click-event',
        name: 'StartFavoriteGuide',
        value1: callbackUrl
      })
    })]
  });
};